import React from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useReviewRequestDialog, useReviewRequestForm } from '../../hooks';
import Form from './Form';

const ReviewRequestDialog = () => {
  const { showDialog } = useReviewRequestDialog();
  const { handleOpenChange } = useReviewRequestForm();

  return (
    <Dialog onOpenChange={handleOpenChange} open={showDialog}>
      <DialogContent className="space-y-4">
        <DialogHeader>
          <DialogTitle>Request a review</DialogTitle>
        </DialogHeader>

        <Form />
      </DialogContent>
    </Dialog>
  );
};

export default ReviewRequestDialog;
